module.exports = __webpack_public_path__ + "static/media/COL.c82b9134.svg";